import ArticleLayout from '@/components/ArticleLayout';

export default function TermsPage() {
  return (
    <ArticleLayout
      title="Terms of Service"
      description="Terms and conditions for using the CSSBuy Spreadsheet resource website."
      breadcrumbs={[
        { label: 'Home', to: '/' },
        { label: 'Terms', to: '/terms' },
      ]}
      lastUpdated="2026-08-30"
    >
      <h2>Acceptance of Terms</h2>
      <p>
        By accessing and using this website, you accept and agree to be bound by these Terms of Service. If you do not agree with any part of these terms, please do not use our website.
      </p>

      <h2>Use of the Website</h2>
      <p>
        This website is an independent informational resource about CSSBuy. You may use the website for personal, non-commercial research purposes only. You agree not to:
      </p>
      <ul>
        <li>Use the website for any illegal or unauthorized purpose</li>
        <li>Attempt to interfere with the website's functionality or security</li>
        <li>Reproduce, duplicate, or copy content for commercial purposes without permission</li>
        <li>Spread malware, viruses, or harmful code</li>
      </ul>

      <h2>Intellectual Property</h2>
      <p>
        All content on this website, including text, images, and graphics, is protected by copyright and other intellectual property laws. You may not reproduce, distribute, or create derivative works without express permission.
      </p>

      <h2>Disclaimer of Warranties</h2>
      <p>
        This website is provided on an "as is" and "as available" basis. We make no warranties, express or implied, regarding the accuracy, reliability, or availability of the website or its content.
      </p>

      <h2>Limitation of Liability</h2>
      <p>
        In no event shall we be liable for any direct, indirect, incidental, or consequential damages arising from your use of or inability to use this website, even if we have been advised of the possibility of such damages.
      </p>

      <h2>Changes to Terms</h2>
      <p>
        We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting. Continued use of the website after changes constitutes acceptance of the new terms.
      </p>

      <h2>Governing Law</h2>
      <p>
        These terms shall be governed by and construed in accordance with applicable laws, without regard to conflict of law principles.
      </p>
    </ArticleLayout>
  );
}